import { GraphQLClient } from 'graphql-request'
import BackendService from './BackendService'
import { getToken } from '../token'

export default class GraphQLService extends BackendService {
  constructor() {
    super()
    this.client = new GraphQLClient(this.graphQlUrl, {
      headers: {
        authorization: 'Bearer ' + this.token
      }
    })
  }
  client() {
    return new GraphQLClient(process.env.GRAPHQL_ENDPOINT, {
      headers: {
        authorization: 'Bearer ' + this.token
      }
    })
  }
}

export const graphql = () => {
  let client = new GraphQLClient(process.env.GRAPHQL_ENDPOINT, {
    credentials: 'include',
    headers: {
      authorization: getToken() ? 'Bearer ' + getToken() : ''
    }
  })
  return client
}



// WEBPACK FOOTER //
// ./src/services/graphql.js